// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// const Foodsettlementpage = () => {
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedDate, setSelectedDate] = useState(""); // Single date picker
//     const [invoiceData, setInvoiceData] = useState(null);
//     const [settlements, setSettlements] = useState([]);
//     const [filteredSettlements, setFilteredSettlements] = useState([]);
//     const { showLoader, hideLoader } = useLoader();
//     // Fetch settlements from API
//     useEffect(() => {
//         const token = localStorage.getItem("authToken");
//         showLoader();
//         axios
//             .get("https://backend.maamaas.com/food/api/settlements/get/all", {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     Accept: "*/*",
//                 },
//             })
//             .then((res) => {
//                 const data = res.data.settlements || res.data;
//                 setSettlements(data);
//                 setFilteredSettlements(data);
//             })
//             .catch((err) => console.error("Error fetching settlements:", err)).finally(() => {
//                 hideLoader();
//             })
//     }, []);

//     // Filter settlements based on Vendor ID and selected date
//     useEffect(() => {
//         let filtered = [...settlements];

//         // Filter by Vendor ID
//         if (searchTerm) {
//             filtered = filtered.filter(item =>
//                 item.vendorId.toString().toLowerCase().includes(searchTerm.toLowerCase())
//             );
//         }

//         // Filter by selected date
//         if (selectedDate) {
//             filtered = filtered.filter(item => {
//                 const settlementDate = new Date(item.settlementDate).toISOString().split("T")[0];
//                 return settlementDate === selectedDate;
//             });
//         }

//         setFilteredSettlements(filtered);
//     }, [searchTerm, selectedDate, settlements]);


//     const handleExport = () => {
//         const headers = ["Vendor ID", "Total Sales", "Service Charges", "To Settle", "Admin Acc", "Vendor Name", "Vendor Acc", "IFSC", "Settlement Date"];
//         const rows = filteredSettlements.map((it) => [
//             it.vendorId,
//             it.totalAmountBeforeTds,
//             it.tdsAmount,
//             it.amountAfterTds,
//             it.superadminAccNo,
//             it.holderName,
//             it.accountNumber,
//             it.ifscCode,
//             it.settlementDate,
//         ]);

//         const csvContent = [headers, ...rows].map(r => r.join(",")).join("\n");
//         const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//         const link = document.createElement("a");
//         link.href = URL.createObjectURL(blob);
//         link.download = "settlements.csv";
//         link.click();
//     };

//     const tableHeaderStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//         fontWeight: "bold",
//         backgroundColor: "#b15cd6",
//         color: "white",
//         padding: 6,
//     };
//     const tableCellStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//         padding: 6,
//     };
//     const filterSelectStyle = {
//         backgroundColor: "#b15cd6",
//         color: "#fff",
//         border: "none",
//         height: "35px",
//         borderRadius: "4px"
//     };
//     return (
//         <div >
//             {/* Filters and Export Button */}
//             <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", marginBottom: 10, gap: 10 }}>
//                 <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                     <input
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         placeholder="Search by Vendor ID"
//                         style={{ padding: 6, width: 180, borderRadius: '10px' }}
//                     />
//                     <input
//                         type="date"
//                         value={selectedDate}
//                         onChange={(e) => setSelectedDate(e.target.value)}
//                         style={filterSelectStyle}
//                     />
//                 </div>
//                 <button onClick={handleExport} style={{ padding: "6px 12px", backgroundColor: "#b15cd6", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>
//                     Export CSV
//                 </button>
//             </div>

//             {/* Table */}
//             <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                 <thead>
//                     <tr>
//                         <th style={tableHeaderStyle}>Vendor ID</th>
//                         <th style={tableHeaderStyle}>Total Sales</th>
//                         <th style={tableHeaderStyle}>Service Charges</th>
//                         <th style={tableHeaderStyle}>Commission Charges</th>
//                         <th style={tableHeaderStyle}>To Settle</th>
//                         <th style={tableHeaderStyle}>Total Cash</th>
//                         <th style={tableHeaderStyle}>Admin Acc</th>
//                         <th style={tableHeaderStyle}>Vendor Name</th>
//                         <th style={tableHeaderStyle}>Vendor Acc</th>
//                         <th style={tableHeaderStyle}>IFSC</th>
//                         <th style={tableHeaderStyle}>Settlement Date</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {filteredSettlements.map(it => (
//                         <tr key={it.adminId}>
//                             <td style={tableCellStyle}>{it.vendorId}</td>
//                             <td style={tableCellStyle}>₹{it.totalAmountBeforeTds}</td>

//                             <td style={tableCellStyle}>-₹{it.tdsAmount}</td>
//                             <td style={tableCellStyle}>-₹{it.commission}</td>
//                             <td style={tableCellStyle}>{it.finalAmount}</td>
//                             <td style={tableCellStyle}>{it.totalCash}</td>
//                             <td style={tableCellStyle}>{it.superadminAccNo}</td>
//                             <td style={tableCellStyle}>{it.holderName}</td>
//                             <td style={tableCellStyle}>{it.accountNumber}</td>
//                             <td style={tableCellStyle}>{it.ifscCode}</td>
//                             <td style={tableCellStyle}>{it.settlementDate}</td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>
//     );
// };

// export default Foodsettlementpage;

























import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const Foodsettlementpage = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedDate, setSelectedDate] = useState(""); // Single date picker
    const [invoiceData, setInvoiceData] = useState(null);
    const [settlements, setSettlements] = useState([]);
    const [filteredSettlements, setFilteredSettlements] = useState([]);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [selectedSettlement, setSelectedSettlement] = useState(null);
    const [newStatus, setNewStatus] = useState("");
    const [remarks, setRemarks] = useState("");
    const [pytMode, setPytMode] = useState("FT");

    const { showLoader, hideLoader } = useLoader();

    // Fetch settlements from API
    useEffect(() => {
        fetchSettlements();
    }, []);

    const fetchSettlements = () => {
        const token = localStorage.getItem("authToken");
        showLoader();
        axios
            .get("https://backend.maamaas.com/food/api/settlements/get/all", {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "*/*",
                },
            })
            .then((res) => {
                const data = res.data.settlements || res.data;
                setSettlements(data);
                setFilteredSettlements(data);
            })
            .catch((err) => console.error("Error fetching settlements:", err)).finally(() => {
                hideLoader();
            })
    };

    // Filter settlements based on Vendor ID and selected date
    useEffect(() => {
        let filtered = [...settlements];

        // Filter by Vendor ID
        if (searchTerm) {
            filtered = filtered.filter(item =>
                item.vendorId.toString().toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Filter by selected date
        if (selectedDate) {
            filtered = filtered.filter(item => {
                const settlementDate = new Date(item.settlementDate).toISOString().split("T")[0];
                return settlementDate === selectedDate;
            });
        }

        setFilteredSettlements(filtered);
    }, [searchTerm, selectedDate, settlements]);

    // Open status update modal
    const handleStatusUpdateClick = (settlement) => {
        setSelectedSettlement(settlement);
        setNewStatus(settlement.paymentStatus);
        setRemarks(settlement.remarks || "");
        setPytMode(settlement.pytMode || "FT");
        setShowStatusModal(true);
    };

    // Update settlement status
    const handleUpdateStatus = () => {
        if (!selectedSettlement || !newStatus) {
            alert("Please select a status");
            return;
        }

        if (!remarks.trim()) {
            alert("Please enter remarks for the status update");
            return;
        }

        const token = localStorage.getItem("authToken");
        const settlementId = selectedSettlement.settlementId;

        // Prepare update data
        const updateData = {
            settlementId: settlementId,
            vendorId: selectedSettlement.vendorId,
            totalCgst: selectedSettlement.totalCgst || 0,
            totalSgst: selectedSettlement.totalSgst || 0,
            totalGrandTotal: selectedSettlement.totalGrandTotal || 0,
            totalServiceCharges: selectedSettlement.totalServiceCharges || 0,
            totalPlatformCharges: selectedSettlement.totalPlatformCharges || 0,
            totalOnlinePayment: selectedSettlement.totalOnlinePayment || 0,
            totalAmountBeforeTds: selectedSettlement.totalAmountBeforeTds || 0,
            tdsAmount: selectedSettlement.tdsAmount || 0,
            amountAfterTds: selectedSettlement.amountAfterTds || 0,
            amountAfterCash: selectedSettlement.amountAfterCash || 0,
            finalAmount: selectedSettlement.finalAmount || 0,
            totalCash: selectedSettlement.totalCash || 0,
            description: selectedSettlement.description || "",
            fromDate: selectedSettlement.fromDate || new Date().toISOString(),
            toDate: selectedSettlement.toDate || new Date().toISOString(),
            totalVendorPlatformCharges: selectedSettlement.totalVendorPlatformCharges || 0,
            totalVendorPlatformChargesGst: selectedSettlement.totalVendorPlatformChargesGst || 0,
            holderName: selectedSettlement.holderName || "",
            accountNumber: selectedSettlement.accountNumber || "",
            ifscCode: selectedSettlement.ifscCode || "",
            settlementDate: selectedSettlement.settlementDate || new Date().toISOString().split('T')[0],
            paymentStatus: newStatus,
            superadminAccNo: selectedSettlement.superadminAccNo || "",
            pytMode: pytMode,
            remarks: remarks,
            totalWalletPayment: selectedSettlement.totalWalletPayment || 0,
            commission: selectedSettlement.commission || 0
        };

        showLoader();
        axios
            .put(`https://backend.maamaas.com/food/api/settlements/update/${settlementId}`, updateData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((res) => {
                alert("Status updated successfully!");
                
                // Refresh data from server to get updated data
                fetchSettlements();
                
                // Close modal
                setShowStatusModal(false);
                setSelectedSettlement(null);
                setNewStatus("");
                setRemarks("");
                setPytMode("FT");
            })
            .catch((err) => {
                console.error("Error updating status:", err);
                alert(`Failed to update status: ${err.response?.data?.message || err.message}`);
            })
            .finally(() => {
                hideLoader();
            });
    };

    const handleExport = () => {
        const headers = ["Vendor ID", "Total Sales", "Service Charges", "Commission Charges", "To Settle", "Total Cash", "From Date", "To Date", "Admin Acc", "Vendor Name", "Vendor Acc", "IFSC", "Settlement Date", "Status", "Remarks", "Payment Mode"];
        const rows = filteredSettlements.map((it) => [
            it.vendorId,
            it.totalAmountBeforeTds,
            it.tdsAmount > 0 ? it.tdsAmount : 0,
            it.commission > 0 ? it.commission : 0,
            it.amountAfterTds,
            it.superadminAccNo,
            it.holderName,
            it.accountNumber,
            it.ifscCode,
            it.settlementDate,
            it.paymentStatus,
            it.remarks || "",
            it.pytMode || "FT",
        ]);

        const csvContent = [headers, ...rows].map(r => r.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "settlements.csv";
        link.click();
    };

    // Get status badge style
    const getStatusStyle = (status) => {
        const baseStyle = {
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: "500",
            display: "inline-block",
            textTransform: "uppercase"
        };

        switch (status) {
            case "PAID":
                return {
                    ...baseStyle,
                    backgroundColor: "#4CAF50",
                    color: "white"
                };
            case "PENDING":
                return {
                    ...baseStyle,
                    backgroundColor: "#FF9800",
                    color: "white"
                };
            default:
                return {
                    ...baseStyle,
                    backgroundColor: "#9E9E9E",
                    color: "white"
                };
        }
    };

    // Get payment mode badge style
    const getPaymentModeStyle = (mode) => {
        const baseStyle = {
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: "500",
            display: 'inline-block'
        };

        switch (mode) {
            case "FT":
                return {
                    ...baseStyle,
                    backgroundColor: "#2196F3",
                    color: "white"
                };
            case "NEFT":
                return {
                    ...baseStyle,
                    backgroundColor: "#4CAF50",
                    color: "white"
                };
            case "RTGS":
                return {
                    ...baseStyle,
                    backgroundColor: "#9C27B0",
                    color: "white"
                };
            case "IMPS":
                return {
                    ...baseStyle,
                    backgroundColor: "#FF9800",
                    color: "white"
                };
            default:
                return {
                    ...baseStyle,
                    backgroundColor: "#9E9E9E",
                    color: "white"
                };
        }
    };

    // Format date to display only date part
    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toISOString().split("T")[0];
    };

    const tableHeaderStyle = {
        border: "1px solid #ddd",
        textAlign: "center",
        fontWeight: "bold",
        backgroundColor: "#b15cd6",
        color: "white",
        padding: "10px 8px",
        fontSize: "13px",
        whiteSpace: "nowrap",
        position: "sticky",
        top: 0,
        zIndex: 10,
    };
    const tableCellStyle = {
        border: "1px solid #ddd",
        textAlign: "center",
        padding: "10px 8px",
        fontSize: "13px",
        whiteSpace: "nowrap",
    };
    const filterSelectStyle = {
        backgroundColor: "#b15cd6",
        color: "#fff",
        border: "none",
        height: "35px",
        borderRadius: "4px"
    };

    // Modal styles
    const modalOverlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '20px',
    };

    const modalContentStyle = {
        backgroundColor: '#fff',
        borderRadius: '8px',
        width: '100%',
        maxWidth: '500px',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    };

    const modalHeaderStyle = {
        padding: '20px',
        borderBottom: '1px solid #eee',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    };

    const modalBodyStyle = {
        padding: '20px',
    };

   return (
        <div className="container-fluid">
            <div className="row" style={{marginTop: "-145px", marginLeft: "-20px"}}>
              
                <div className="col-lg-11 food-accounts-data-scroll" style={{ height: "85vh", overflowY: "auto", scrollbarWidth: "none" }}>
                    {/* Filters and Export Button */}
                    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", marginBottom: 10, gap: 10 }}>
                        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                            <input
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Search by Vendor ID"
                                style={{ padding: 6, width: 180, borderRadius: '10px' }}
                            />
                            <input
                                type="date"
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                                style={filterSelectStyle}
                            />
                        </div>
                        <button onClick={handleExport} style={{ padding: "6px 12px", backgroundColor: "#b15cd6", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>
                            Export CSV
                        </button>
                    </div>

                    {/* Table Container with Horizontal Scroll */}
                    <div style={{ 
                        width: "100%", 
                        overflowX: "auto",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        maxHeight: "70vh",
                        position: "relative"
                    }}>
                        {/* Table */}
                        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "1500px" }}>
                            <thead>
                                <tr>
                                    <th style={tableHeaderStyle}>Vendor ID</th>
                                    <th style={tableHeaderStyle}>Total Sales</th>
                                    <th style={tableHeaderStyle}>Service Charges</th>
                                    <th style={tableHeaderStyle}>Commission Charges</th>
                                    <th style={tableHeaderStyle}>To Settle</th>
                                    <th style={tableHeaderStyle}>Total Cash</th>
                                    <th style={tableHeaderStyle}>From Date</th>
                                    <th style={tableHeaderStyle}>To Date</th>
                                    <th style={tableHeaderStyle}>Admin Acc</th>
                                    <th style={tableHeaderStyle}>Vendor Name</th>
                                    <th style={tableHeaderStyle}>Vendor Acc</th>
                                    <th style={tableHeaderStyle}>IFSC</th>
                                    <th style={tableHeaderStyle}>Settlement Date</th>
                                    <th style={tableHeaderStyle}>Status</th>
                                    <th style={tableHeaderStyle}>Remarks</th>
                                    <th style={tableHeaderStyle}>Payment Mode</th>
                                    <th style={tableHeaderStyle}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredSettlements.map(it => (
                                    <tr key={it.settlementId || it.vendorId}>
                                        <td style={tableCellStyle}>{it.vendorId}</td>
                                        <td style={tableCellStyle}>₹{it.totalAmountBeforeTds}</td>
                                        <td style={tableCellStyle}>
                                            {it.tdsAmount > 0 ? `₹${it.tdsAmount}` : "₹0"}
                                        </td>
                                        <td style={tableCellStyle}>
                                            {it.commission > 0 ? `₹${it.commission}` : "₹0"}
                                        </td>
                                        <td style={tableCellStyle}>₹{it.finalAmount}</td>
                                        <td style={tableCellStyle}>₹{it.totalCash}</td>
                                        <td style={tableCellStyle}>{formatDate(it.fromDate)}</td>
                                        <td style={tableCellStyle}>{formatDate(it.toDate)}</td>
                                        <td style={tableCellStyle}>{it.superadminAccNo}</td>
                                        <td style={tableCellStyle}>{it.holderName}</td>
                                        <td style={tableCellStyle}>{it.accountNumber}</td>
                                        <td style={tableCellStyle}>{it.ifscCode}</td>
                                        <td style={tableCellStyle}>{it.settlementDate}</td>
                                        <td style={tableCellStyle}>
                                            <span style={getStatusStyle(it.paymentStatus)}>
                                                {it.paymentStatus}
                                            </span>
                                        </td>
                                        <td style={tableCellStyle}>
                                            {it.remarks ? (
                                                <div style={{
                                                    maxWidth: '200px',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    cursor: 'pointer'
                                                }}
                                                title={it.remarks}
                                                onClick={() => alert(`Remarks: ${it.remarks}`)}
                                                >
                                                    {it.remarks}
                                                </div>
                                            ) : "-"}
                                        </td>
                                        <td style={tableCellStyle}>
                                            <span style={getPaymentModeStyle(it.pytMode)}>
                                                {it.pytMode || "FT"}
                                            </span>
                                        </td>
                                        <td style={tableCellStyle}>
                                            <button
                                                onClick={() => handleStatusUpdateClick(it)}
                                                style={{
                                                    padding: "4px 8px",
                                                    backgroundColor: "#2196F3",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "12px"
                                                }}
                                            >
                                                Update Status
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Status Update Modal */}
                    {showStatusModal && selectedSettlement && (
                        <div style={modalOverlayStyle} onClick={(e) => e.target === e.currentTarget && setShowStatusModal(false)}>
                            <div style={modalContentStyle}>
                                <div style={modalHeaderStyle}>
                                    <h3 style={{ margin: 0, color: '#333' }}>
                                        Update Settlement Status
                                    </h3>
                                    <button
                                        onClick={() => setShowStatusModal(false)}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            fontSize: '20px',
                                            cursor: 'pointer',
                                            color: '#666',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        ✕
                                    </button>
                                </div>
                                
                                <div style={modalBodyStyle}>
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Settlement ID
                                        </label>
                                        <input
                                            type="text"
                                            value={selectedSettlement.settlementId}
                                            readOnly
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'not-allowed'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Vendor ID
                                        </label>
                                        <input
                                            type="text"
                                            value={selectedSettlement.vendorId}
                                            readOnly
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'not-allowed'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Vendor Name
                                        </label>
                                        <input
                                            type="text"
                                            value={selectedSettlement.holderName || "-"}
                                            readOnly
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'not-allowed'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Current Status
                                        </label>
                                        <div style={getStatusStyle(selectedSettlement.paymentStatus)}>
                                            {selectedSettlement.paymentStatus}
                                        </div>
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Payment Mode
                                        </label>
                                        <select
                                            value={pytMode}
                                            onChange={(e) => setPytMode(e.target.value)}
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px'
                                            }}
                                        >
                                            <option value="FT">FT (Fund Transfer)</option>
                                            <option value="NEFT">NEFT</option>
                                            <option value="RTGS">RTGS</option>
                                            <option value="IMPS">IMPS</option>
                                        </select>
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            New Status *
                                        </label>
                                        <select
                                            value={newStatus}
                                            onChange={(e) => setNewStatus(e.target.value)}
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px'
                                            }}
                                            required
                                        >
                                            <option value="">Select Status</option>
                                            <option value="PENDING">PENDING</option>
                                            <option value="PAID">PAID</option>
                                        </select>
                                    </div>

                                    <div style={{ marginBottom: '20px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Remarks *
                                        </label>
                                        <textarea
                                            value={remarks}
                                            onChange={(e) => setRemarks(e.target.value)}
                                            placeholder="Enter remarks for status update (required)"
                                            rows="3"
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                resize: 'vertical'
                                            }}
                                            required
                                        />
                                        <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                            Please provide a reason for the status change
                                        </small>
                                    </div>

                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <button
                                            onClick={handleUpdateStatus}
                                            style={{
                                                flex: 1,
                                                padding: '10px',
                                                backgroundColor: '#4CAF50',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Update Status
                                        </button>
                                        <button
                                            onClick={() => setShowStatusModal(false)}
                                            style={{
                                                flex: 1,
                                                padding: '10px',
                                                backgroundColor: '#f5f5f5',
                                                color: '#333',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
              
            </div>
        </div>
    );
};

export default Foodsettlementpage;